import { Container, Row, Col, Table, Button, Card } from 'react-bootstrap';
import Footer from './components/Footer';

export default function Registration() {

  return (
    <>
      <section id="hero" className="hero hero-background position-relative">
        <Container >
          <Row className="align-items-center ">
              <Col md={8} lg={6} className=''>
                <h1 className="display-3 fw-bold text-white">Registration</h1>
              </Col>
            </Row>
        </Container>
        </section>
      <section id="content">
      <Container className=''>
        <Row className='my-5'>
          <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2  border-bpp-pink' data-aos="fade-up" data-aos-delay="50">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Poster abstract submission</span><br></br>August 5, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2 border-bpp-pink' data-aos="fade-up" data-aos-delay="250">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Early Bird Registration</span><br></br>July 15, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
        </Row>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='py-5'>
            <h2 className='h1 mb-4 purple-h'>Registration is now open</h2>
            <p>Please complete the online registration form and ensure that all required documentation is submitted during the process. After submitting your registration, you will receive a pro-forma invoice by email.</p>
            <div className='shadow my-4 bpp-table-wrapper'>
            <Table responsive className='bpp-table mb-0 rounded'>
              <thead>
                <tr>
                  <th align="left">Category</th>
                  <th align="left">Price*</th>
                  <th align="left">Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Early Bird – Student Registration</td>
                  <td className='text-nowrap'>450 €</td>
                  <td>Proof of student status must be presented at the time of registration**</td>
                </tr>
                <tr>
                  <td>Early Bird – Standard Registration</td>
                  <td className='text-nowrap'>650 €</td>
                  <td>—</td>
                </tr>
                <tr>
                  <td>Regular – Student Registration</td>
                  <td className='text-nowrap'>550 €</td>
                  <td>Proof of student status must be presented at the time of registration**</td>
                </tr>
                <tr>
                  <td>Regular – Standard Registration</td>
                  <td className='text-nowrap'>750 €</td>
                  <td>—</td>
                </tr>
              </tbody>
            </Table>
            </div>
          
            <Button href="https://ec.europa.eu/eusurvey/runner/BPP2026_Registration" target='_blank' variant="bpp-pink" size="lg" className='text-white my-3'>Register now</Button>

            <h3 className='mt-5 '>Conference dinner</h3>
            <p>The costs for the conference dinner (75 €/person) are not included in the registration fee and must be paid separately. Please indicate in the registration form whether you will attend the conference dinner. The dinner fee will be added to your pro-forma invoice and, following payment, to the final invoice. If an accompanying person will join the dinner, please specify this and indicate whether their dinner invoice should be issued separately.</p>

            <h3 className=' mt-5 '>Student Registration </h3>
            <p>The early-bird student and regular student rates require valid proof of student status. Verification must be uploaded during the registration process; registration cannot proceed without the required documentation.</p>

            <h3 className=' mt-5 '>Terms & Conditions</h3>
            <p>Before completing your registration, please review the full <a href="files/BPP26_Terms and Conditions.pdf" target='_blank'>Terms & Conditions.</a></p>
          </Col>
        </Row>
        
      </Container>
    </section>
      <Footer />
    </>
  );
}
 